import scallop3Src from '@images/marketing/HIW-PriceLargeDogs.jpg';
import scallop2Src from '@images/marketing/HIW-PriceMediumDogs.jpg';
import scallop1Src from '@images/marketing/HIW-PriceSmallDogs.jpg';
export var pricingContent = {
    pricingItems: [
        {
            title: 'Small Dogs',
            weight: '5 - 25 lbs',
            priceRange: '$1.60 - $2.60/Meal',
            imageData: {
                src: scallop1Src,
                alt: 'Small Dogs',
            },
        },
        {
            title: 'Medium Dogs',
            weight: '26 - 45 lbs',
            priceRange: '$2.61 - $3.60/Meal',
            imageData: {
                src: scallop2Src,
                alt: 'Medium Dogs',
            },
        },
        {
            title: 'Large Dogs',
            weight: '45+',
            priceRange: '$3.61 - $4.60/Meal',
            imageData: {
                src: scallop3Src,
                alt: 'Large Dogs',
            },
        },
    ],
    ctaUrl: '/profile',
};
export * from '../CostPerMeal/content';
